import { convert2FirebaseJson } from "../../../app/utils/utils";
import { logger } from "../../../app/utils/utils";
import configureStore from "../../../store/configureStore";

export default function dbUpdateRecord(data, idToken) {
  return dispatch => {
    const state = configureStore.getState();
    let fbDbUrl = state.db.team.fbDbUrl;
    let fbCloudUrl = state.db.team.fbCloudUrl;

    let fetchQuery = fbDbUrl + "/" + data.path + ".json";
    fetchQuery = fetchQuery + "?auth=" + idToken;
    return fetch(fetchQuery, {
      method: "PATCH",
      body: convert2FirebaseJson(data.payload)
    })
      .then(res => res.json())
      .then(parsedRes => {
        console.log(JSON.stringify(parsedRes));
        logger(
          "DEBUG",
          "dbUpdateRecord(data)",
          "Updating record successful -> " + JSON.stringify(parsedRes)
        );
        return parsedRes.key;
      })
      .catch(err => {
        logger(
          "DEBUG",
          "dbUpdateRecord(data)",
          "Record update failed -> " + err
        );
        alert(
          "---We are unable to complete your request at this time, please check your network connection or contact support[dbUpdate]"
        );
        console.log(
          "---We are unable to complete your request at this time, please check your network connection or contact support[dbUpdate]"
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/Services/Firebase/Generic/dbUpdateRecord.js